import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const rechargeActivityRoutes: CustomRouteRecordRaw = {
  path: 'recharge-activity',
  name: 'rechargeActivity',
  component: EmptyLayout,
  meta: {
    title: '充值活动管理',
    iconfont: 'icon-money-cny-box-line',
    requiredPermission: 'recharge.activity',
  },
  children: [
    {
      path: 'recharge-activity-list',
      name: 'rechargeActivityList',
      component: () => import('@/views/recharge-activity/recharge-activity-list.vue'),
      meta: {
        title: '充值活动列表',
        requiredPermission: 'recharge.activity.list',
      },
    },
    {
      path: 'recharge-give-log',
      name: 'rechargeGiveLog',
      component: () => import('@/views/recharge-activity/activity-give-log.vue'),
      meta: {
        title: '充值赠送记录',
        requiredPermission: 'recharge.activity.give.log',
      },
    }
  ]
}
